import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import TranslateIcon from "@mui/icons-material/Translate";
import GTranslateIcon from "@mui/icons-material/GTranslate";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    i18n.changeLanguage(i18n.language === "en" ? "ar" : "en");
  };

  return (
    <Button
      onClick={toggleLanguage}
      variant="contained"
      color="primary"
      startIcon={i18n.language === "en" ? <GTranslateIcon /> : <TranslateIcon />}
      sx={{ fontWeight: "bold", textTransform: "none" }}
    >
      {i18n.language === "en" ? "العربية " : "English "}
    </Button>
  );
};

export default LanguageSwitcher;
